module.exports = __webpack_public_path__ + "img/tu.ade9018d.png";